import { eventbus } from 'packages/eventbus';

export const casesEventChannel = eventbus<{
	refetchCasesByStatus: (statusId: number) => void;
	forceUpdateCasesList: () => void;
}>();
